var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettingClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.821962 13.178C1.13451 13.4905 1.55835 13.666 2.0003 13.666C2.44224 13.666 2.86608 13.4905 3.17863 13.178L7.0003 9.35637L10.822 13.178C11.1363 13.4816 11.5573 13.6496 11.9943 13.6458C12.4313 13.642 12.8493 13.4667 13.1583 13.1577C13.4673 12.8487 13.6426 12.4307 13.6464 11.9937C13.6502 11.5567 13.4822 11.1357 13.1786 10.8214L9.35696 6.9997L13.1786 3.17803C13.4822 2.8637 13.6502 2.44269 13.6464 2.0057C13.6426 1.56871 13.4673 1.15068 13.1583 0.841671C12.8493 0.532657 12.4313 0.357376 11.9943 0.353579C11.5573 0.349781 11.1363 0.517772 10.822 0.821369L7.0003 4.64304L3.17863 0.821369C2.86429 0.517772 2.44329 0.349781 2.00629 0.353579C1.5693 0.357376 1.15128 0.532657 0.842264 0.841671C0.533251 1.15068 0.357969 1.56871 0.354172 2.0057C0.350375 2.44269 0.518365 2.8637 0.821962 3.17803L4.64363 6.9997L0.821962 10.8214C0.50951 11.1339 0.333984 11.5578 0.333984 11.9997C0.333984 12.4416 0.50951 12.8655 0.821962 13.178Z",
    fill: "#00ACB9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingClose);
export default __webpack_public_path__ + "static/media/settingClose.e59d52f9a8e7eeb824e5d62962086ae5.svg";
export { ForwardRef as ReactComponent };